export const AUTHENTICATE = 'AUTHENTICATE';
export const TOKEN = 'TOKEN';
export const PUSH_TOKEN = 'PUSH_TOKEN';
export const LOGOUT = 'LOGOUT';
